import { useLocale } from 'next-intl';
import { localeToLang } from '@/shared/i18n/localeToLang';
import { LocalizedMedia } from '@/shared/model/Language';
import { Media } from '@/shared/ui/media/types';

export const useGetLocalizedMedia = () => {
    const locale = useLocale();
    return (media: LocalizedMedia[] | Media[] = []) => {
        return media.map((m) => ('url' in m ? m : m[localeToLang(locale)])).filter((m) => m !== undefined);
    };
};
